export const CONNECTIONS_ROUTE = 'connections';

export const connectionsKeys = {
  TOOLKITS: 'CONNECTIONS_TOOLKITS',
  CATEGORIES: 'CONNECTIONS_CATEGORIES',
  MINE: 'CONNECTIONS_MINE',
};
